// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.lease.LeaseWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseWebApiHandler_archiveLease,
  LeaseWebApiHandler_createNewLease,
  LeaseWebApiHandler_createNewLeaseForApplication,
  LeaseWebApiHandler_deactivateLease,
  LeaseWebApiHandler_getLease,
  LeaseWebApiHandler_getLease_Path,
  LeaseWebApiHandler_getLeaseV2,
  LeaseWebApiHandler_getLeaseV2_Path,
} from '@zg-rentals/ts-leasing-client';

import type {
  ArchiveLeaseRequestDto,
  CreateNewLeaseForApplicationRequestDto,
  CreateNewLeaseForApplicationResponseDto,
  CreateNewLeaseRequestDto,
  CreateNewLeaseResponseDto,
  GetLeaseResponseDto,
  GetLeaseV2ResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface DeactivateLeaseParams {
  leaseId: number;
}
interface GetLeaseParams {
  leaseId: number;
}
interface GetLeaseV2Params {
  leaseId: number;
}

export interface LeaseWebApiHandler_archiveLease_Args {
  postData: ArchiveLeaseRequestDto;
}

export type LeaseWebApiHandler_archiveLease_Options = UseMutationOptions<
  void,
  unknown,
  LeaseWebApiHandler_archiveLease_Args
>;

/**
 * archive lease for user
 */
export const useLeaseWebApiHandler_archiveLease = ({
  httpClient,
  ...options
}: Omit<LeaseWebApiHandler_archiveLease_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseWebApiHandler_archiveLease_Args) =>
      LeaseWebApiHandler_archiveLease(args.postData, httpClient),
  });
};

export interface LeaseWebApiHandler_createNewLease_Args {
  postData: CreateNewLeaseRequestDto;
}

export type LeaseWebApiHandler_createNewLease_Options = UseMutationOptions<
  CreateNewLeaseResponseDto,
  unknown,
  LeaseWebApiHandler_createNewLease_Args
>;

/**
 * create new lease
 */
export const useLeaseWebApiHandler_createNewLease = ({
  httpClient,
  ...options
}: Omit<LeaseWebApiHandler_createNewLease_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseWebApiHandler_createNewLease_Args) =>
      LeaseWebApiHandler_createNewLease(args.postData, httpClient),
  });
};

export interface LeaseWebApiHandler_createNewLeaseForApplication_Args {
  postData: CreateNewLeaseForApplicationRequestDto;
}

export type LeaseWebApiHandler_createNewLeaseForApplication_Options = UseMutationOptions<
  CreateNewLeaseForApplicationResponseDto,
  unknown,
  LeaseWebApiHandler_createNewLeaseForApplication_Args
>;

/**
 * create new lease with tenants set from application
 */
export const useLeaseWebApiHandler_createNewLeaseForApplication = ({
  httpClient,
  ...options
}: Omit<LeaseWebApiHandler_createNewLeaseForApplication_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseWebApiHandler_createNewLeaseForApplication_Args) =>
      LeaseWebApiHandler_createNewLeaseForApplication(args.postData, httpClient),
  });
};

export interface LeaseWebApiHandler_deactivateLease_Args {
  getParams: DeactivateLeaseParams;
}

export type LeaseWebApiHandler_deactivateLease_Options = UseMutationOptions<
  void,
  unknown,
  LeaseWebApiHandler_deactivateLease_Args
>;

/**
 * manually deactivate month-to-month lease (move from active to expired)
 */
export const useLeaseWebApiHandler_deactivateLease = ({
  httpClient,
  ...options
}: Omit<LeaseWebApiHandler_deactivateLease_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseWebApiHandler_deactivateLease_Args) =>
      LeaseWebApiHandler_deactivateLease(args.getParams, httpClient),
  });
};

export type LeaseWebApiHandler_getLease_Options = UseQueryOptions<
  GetLeaseResponseDto,
  unknown,
  GetLeaseResponseDto,
  readonly [string, GetLeaseParams]
>;

const LeaseWebApiHandler_getLease_GetKey = (getParams: GetLeaseParams) =>
  [LeaseWebApiHandler_getLease_Path, getParams] as const;

export const LeaseWebApiHandler_getLease_queryOptions = (
  getParams: GetLeaseParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeaseWebApiHandler_getLease_GetKey(getParams),
    queryFn: () => LeaseWebApiHandler_getLease(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get lease
 */
export const useLeaseWebApiHandler_getLease = (
  getParams: GetLeaseParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseWebApiHandler_getLease_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...LeaseWebApiHandler_getLease_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeaseWebApiHandler_getLease.getKey = LeaseWebApiHandler_getLease_GetKey;

export type LeaseWebApiHandler_getLeaseV2_Options = UseQueryOptions<
  GetLeaseV2ResponseDto,
  unknown,
  GetLeaseV2ResponseDto,
  readonly [string, GetLeaseV2Params]
>;

const LeaseWebApiHandler_getLeaseV2_GetKey = (getParams: GetLeaseV2Params) =>
  [LeaseWebApiHandler_getLeaseV2_Path, getParams] as const;

export const LeaseWebApiHandler_getLeaseV2_queryOptions = (
  getParams: GetLeaseV2Params,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeaseWebApiHandler_getLeaseV2_GetKey(getParams),
    queryFn: () => LeaseWebApiHandler_getLeaseV2(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get lease
 */
export const useLeaseWebApiHandler_getLeaseV2 = (
  getParams: GetLeaseV2Params,
  {
    httpClient,
    ...options
  }: Omit<LeaseWebApiHandler_getLeaseV2_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...LeaseWebApiHandler_getLeaseV2_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeaseWebApiHandler_getLeaseV2.getKey = LeaseWebApiHandler_getLeaseV2_GetKey;
